import Validator from './validator'


export default Validator